import React from "react";
import ReactDOM from "react-dom";

import ShareItem from "../src/features/share-item/src";

const containers = document.querySelectorAll(".share-item");

containers.forEach(container => {
  document.addEventListener("DOMContentLoaded", () => {
    const isAgent = container.getAttribute("is-agent") === "true";
    const itemAddress = container.getAttribute("item-address");
    const itemArea = container.getAttribute("item-area");
    const itemId = container.getAttribute("item-id");
    const itemType = container.getAttribute("item-type");
    const sitekey = container.getAttribute("sitekey");

    const event = new CustomEvent(`TriggerShareItemForm-${itemType}-${itemId}`);
    const eventTriggerElements = document.getElementsByClassName(
      `jsTriggerShareItemForm-${itemType}-${itemId}`
    );

    [...eventTriggerElements].forEach(element => {
      element.addEventListener("click", () => {
        document.dispatchEvent(event);
      });
    });

    ReactDOM.render(
      <ShareItem
        isAgent={isAgent}
        itemAddress={itemAddress}
        itemArea={itemArea}
        itemId={itemId}
        itemType={itemType}
        siteKey={sitekey}
      />,
      container
    );
  });
});
